var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDeprecated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.084C25.1758 22.084 29.375 17.8848 29.375 12.709C29.375 7.5332 25.1758 3.33398 20 3.33398C14.8242 3.33398 10.625 7.5332 10.625 12.709C10.625 17.8848 14.8242 22.084 20 22.084ZM28.3333 24.1673H24.7461C23.3008 24.8314 21.6927 25.209 20 25.209C18.3073 25.209 16.7057 24.8314 15.2539 24.1673H11.6666C7.06378 24.1673 3.33331 27.8978 3.33331 32.5007V33.5423C3.33331 35.2676 4.73305 36.6673 6.45831 36.6673H33.5416C35.2669 36.6673 36.6666 35.2676 36.6666 33.5423V32.5007C36.6666 27.8978 32.9362 24.1673 28.3333 24.1673Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDeprecated);
export default __webpack_public_path__ + "static/media/user_deprecated.ba7e0ae5b04dd32bc781c1aaf4e6f98a.svg";
export { ForwardRef as ReactComponent };